import { LayoutTypes } from "@/store/app/state";
import { ChatsState } from "@/store/chats/state";

export const getIsMobileLayoutDisplayed = (
  selectedChat: ChatsState["selectedChat"],
  layoutType: LayoutTypes,
) => {
  return !selectedChat || layoutType === LayoutTypes.DESKTOP;
};
